import {RouteRecordRaw} from 'vue-router'
import Search from "@/views/Search.vue";
import Menu from "@/components/Menu.vue";
import Dashboard from "@/views/Dashboard.vue";
import HomeFiltered from "@/views/HomeFiltered.vue";
import {AlertState} from "@/types";
import ListaClienti from "@/views/ListaClienti.vue";
import DettaglioAzienda from "@/views/DettaglioAzienda.vue";
import HomeCrm from "@/views/HomeCrm.vue";
import Contatti from "@/views/Contatti.vue";
import Attivita from "@/views/Attivita.vue";
import FormContatto from "@/views/FormContatto.vue";
import DettaglioContatto from "@/views/DettaglioContatto.vue";
import NuovoCliente from "@/views/NuovoCliente.vue";
import TerminiCliente from "@/views/TerminiCliente.vue";
import SottoprogettiCliente from "@/views/SottoprogettiCliente.vue";
import StoricoCliente from "@/views/StoricoCliente.vue";

const crmRoutes: Array<RouteRecordRaw> = [
    {
        path: '/crm/',
        meta: {'app': 'crm'},
        components: {
            default: HomeCrm,
            nav: Menu
        },
        props: true,
        children: [
            {
                path: '',
                component: Dashboard,
                name: 'Dashboard'
            },
            {
                path: 'richiama-entro/',
                component: HomeFiltered,
                name: 'RichiamaEntro',
                props:{
                    filterState: AlertState.PENDENTE
                }
            },
            {
                path: 'alert-scaduti/',
                component: HomeFiltered,
                name: 'AlertScaduti',
                props:{
                    filterState: AlertState.SCADUTO
                }
            },
            {
                path: 'alert-scadenza/',
                component: HomeFiltered,
                name: 'AlertScadenza',
                props:{
                    filterState: AlertState.IN_SCADENZA
                }
            },
            {
                path: 'clienti/',
                name: 'ListaClienti',
                component: ListaClienti,
            },
            {
                path: 'aziende/:id/',
                name: 'DettaglioAzienda',
                component: DettaglioAzienda,
                props: true
            },
            {
                path: 'aziende/:id/storico',
                name: 'StoricoCliente',
                component: StoricoCliente,
                props: true
            },
            {
                path: '/aziende/:id/contatti',
                name: 'Contatti',
                component: Contatti,
                props: true
            },
            {
                path: '/aziende/:id/attivita',
                name: 'Attivita',
                component: Attivita,
                props: true
            },
            {
                path: '/aziende/:id/termini_condizioni',
                name: 'TerminiCondizioni',
                component: TerminiCliente,
                props: true
            },
            {
                path: '/aziende/:id/sottoprogetti',
                name: 'SottoprogettiCliente',
                component: SottoprogettiCliente,
                props: true
            },
            {
                path: '/aziende/:id/contatti/create',
                name: 'FormContatto',
                component: FormContatto,
                props: true
            },
            {
                path: '/aziende/:id/contatti/:cid',
                name: 'DettaglioContatto',
                component: DettaglioContatto,
                props: true
            },
            // {
            //     path: '/dettaglio-progetto',
            //     name: 'DettaglioProgetto',
            //     component: DettaglioProgetto,
            // },
            {
                path: '/nuovo-cliente',
                name: 'NuovoCliente',
                component: NuovoCliente,
            },
            {
                path: '/search',
                name: 'Search',
                component: Search,
                props: true
            },
        ],
    },
]

export default crmRoutes
